import { render, staticRenderFns } from "./BulkPatientImportForm.vue?vue&type=template&id=3e03453e"
import script from "./BulkPatientImportForm.vue?vue&type=script&lang=js"
export * from "./BulkPatientImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports